import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  // ─── Public routes ─────────────────────────────
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import(/* webpackChunkName: "menu" */ '../views/MenuView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue')
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import(/* webpackChunkName: "checkout" */ '../views/CheckoutView.vue')
  },
  {
    path: '/order-confirmation',
    name: 'order-confirmation',
    component: () => import(/* webpackChunkName: "checkout" */ '../views/OrderConfirmationView.vue')
  },

  // ─── Admin routes ───────────────────────────────
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AdminLogin.vue'),
    meta: { guestOnly: true }
  },
  {
    path: '/admin',
    redirect: '/admin/dashboard'
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AdminDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/menu',
    name: 'admin-menu',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AdminMenu.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/testimonials',
    name: 'admin-testimonials',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AdminTestimonials.vue'),
    meta: { requiresAuth: true }
  },

  // ─── Catch-all ──────────────────────────────────
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0, behavior: 'smooth' }
  }
})

// Auth guard
router.beforeEach((to, _from, next) => {
  const isAuth = store.getters['admin/isAuthenticated']

  if (to.meta.requiresAuth && !isAuth) {
    next({ name: 'admin-login' })
  } else if (to.meta.guestOnly && isAuth) {
    next({ name: 'admin-dashboard' })
  } else {
    next()
  }
})

export default router
